import { useState, useEffect } from 'react';
import client from '../../helpers/Client';
import { FormControl, FormErrorMessage, FormLabel, Select } from '@chakra-ui/react';

export default function TeamSelect({
  resellerID,
  selectedTeamURL,
  setSelectedTeamURL,
  selectedTeamErrorMsg
}){
  const [teams, setTeams] = useState();

  useEffect(() => {
    if (!resellerID) return;
    client.get('/teams/', {params: {reseller: resellerID}})
      .then((response) => setTeams(response.data))
      .catch((error) => {
        console.error('Error fetching teams:', error);
      });
  }, [resellerID]);

  return (
    <FormControl isInvalid={selectedTeamErrorMsg}>
      <FormLabel>Takım</FormLabel>
      <Select
        value={selectedTeamURL}
        onChange={(e) => {
          setSelectedTeamURL(e.target.value);
        }}
      >
        <option value=''>Takım Seçilmemiş</option>
        {(teams && teams.length > 0) ?
          teams.map((team) => (
            <option key={team.url} value={team.url}>
              {team.name}
            </option>
         )) : <option disabled>Seçilebilir takım yok, bayi ataması yapınız.</option>
        }
      </Select>
      {selectedTeamErrorMsg && <FormErrorMessage>{selectedTeamErrorMsg}</FormErrorMessage>}
    </FormControl>
  )
}
